module.exports = __webpack_public_path__ + "img/r-149.25aab243.jpg";